import type { Control, UseFormRegister } from 'react-hook-form';
import type { PropsWithChildren } from 'react';
import { errorToMessageString, mapCellTypeToInputType } from '../../../common';
import get from 'lodash/get';
import type { TTableCellContent } from '../../atoms';
import { InputWrapper } from '../../atoms';
import type { FeeRowProps } from '../../../common/utils/table';
import { isRowVisible } from '../../../common/utils/table';
import type { FieldErrors } from 'react-hook-form/dist/types/errors';

export const ComplexRowInputHandler = <Schema extends z.ZodTypeAny>({
  row: { title, content, name, contentType },
  row,
  control,
  errors,
  register,
  children
}: PropsWithChildren<{
  row: FeeRowProps<Schema>;
  control: Control<Schema>;
  errors: FieldErrors<Schema>;
  register: UseFormRegister<Schema>;
}>) => {
  if (!isRowVisible(row)) {
    return null;
  }

  const errorMessage = errorToMessageString(get(errors, name, ''));

  const type = mapCellTypeToInputType({
    contentType,
    content
  } as TTableCellContent);

  if (type === 'table') {
    if (!('tableConfig' in row)) {
      throw new Error('Table rows must have tableConfig');
    }

    return (
      <InputWrapper
        name={name}
        type={type}
        label={title}
        control={control}
        register={register}
        hideErrorMessage
        errorMessage={errorMessage}
        tableConfig={row.tableConfig}
      >
        {children}
      </InputWrapper>
    );
  }

  return (
    <InputWrapper
      name={name}
      type={type}
      label={title}
      register={register}
      errorMessage={errorMessage}
    />
  );
};
